import React, { useState} from "react";
import JsCodeEditor from "../../../components/JsCodeEditor";
import { toast } from 'react-toastify';

const SettingTab = ({updateChatTabData,chatTabData}) => {
    const [activeSettingTab, setActiveSettingTabsElements] = useState("main");
    const [isEnableExternalLink, setIsEnableExternalLink] = useState(Number(chatTabData?.setting_is_enable_external_links || 0));
    const [isEnableNewTabLink, setIsEnableNewTabLink] = useState(Number(chatTabData?.setting_is_open_links_in_new_tab || 0));
    const [selectedSetingTabRatingFormatSpacing, setSetingTabRatingFormatSpacing] = useState(chatTabData?.setting_rating_format || '');
    const [showSetingTabRatingFormatSpacingDropdown, setShowSetingTabRatingFormatSpacingDropdown] = useState(false);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(chatTabData.setting_custom_js);

    //Handle Enable External Link on Change
    const handleEnableExternalLinkChange = (e) => {
        const checked = e.target.checked;
        setIsEnableExternalLink(checked);
        updateChatTabData("setting_is_enable_external_links", checked); 
    };

    //Handle Enable New Tab Link on Change
    const handleEnableNewTabLinkChange = (e) => {
        const checked = e.target.checked;
        setIsEnableNewTabLink(checked);
        updateChatTabData("setting_is_open_links_in_new_tab", checked); 
    };

    //Rating Format download on Change
    const toggleSetingTabRatingFormatSpacingDropdown = () => {
        setShowSetingTabRatingFormatSpacingDropdown(!showSetingTabRatingFormatSpacingDropdown);
    };
    //Rating Format on Change
    const handleSetingTabRatingFormatSpacingSelect = (spacing) => {
        setSetingTabRatingFormatSpacing(spacing);
        setShowSetingTabRatingFormatSpacingDropdown(false);
        updateChatTabData("setting_rating_format", spacing); 
    };

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateChatTabData("setting_custom_js", code);
    };

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => {
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="side-baar-inner-setting">
            {activeSettingTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Enable External Links</span>
                            <div className="form-group">
                                <input
                                    type="checkbox"
                                    id="setting_enable_external_links_toggle"
                                    className="chkbx-toggle"
                                    checked={isEnableExternalLink}
                                    onChange={handleEnableExternalLinkChange}
                                />
                                <label htmlFor="setting_enable_external_links_toggle"></label>
                            </div>
                        </div>
                        {isEnableExternalLink && (
                            <div className="box-header-row last-border-none">
                                <span>Open Link  in New Tab</span>
                                <div className="form-group">
                                    <input
                                        type="checkbox"
                                        id="setting_open_link_in_new_tab_toggle"
                                        className="chkbx-toggle"
                                        checked={isEnableNewTabLink}
                                        onChange={handleEnableNewTabLinkChange}
                                    />
                                    <label htmlFor="setting_open_link_in_new_tab_toggle"></label>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row last-border-none">
                            <span>Rating Format</span>
                            <div className="salcete-font">
                                <button><em onClick={toggleSetingTabRatingFormatSpacingDropdown}>{selectedSetingTabRatingFormatSpacing}</em>
                                    {showSetingTabRatingFormatSpacingDropdown && (
                                        <>
                                        <ul className="dropdown-list">
                                            {['4.9', '4.90'].map((spacing) => (
                                                <li key={spacing} onClick={() => handleSetingTabRatingFormatSpacingSelect(spacing)}>
                                                    {spacing}
                                                </li>
                                            ))}
                                        </ul>
                                        </>
                                    )}</button>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li><button onClick={() => setActiveSettingTabsElements("custome_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingTab === "custome_js" && (
                <>
                    <div className="inner-box-layout">
                        <span>  <button onClick={() => setActiveSettingTabsElements("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom JS Editor</span>
                        <div className="css-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <button className="validate" onClick={handleValidateClick}>Validate</button>
                        </div>
                        <p>Tip: It is recommended to use the CSS classes with the “es” prefix, as these are specially designed for stable customization. Please note, while these classes are intended to be more static, we cannot guarantee that they will remain unchanged in future updates.</p>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingTab;